import { FileText } from "lucide-react"

export function CallSummary({ summary }: { summary: string }) {
  return (
    <div className="w-full min-w-0 rounded-lg border border-blue-200 bg-blue-50 p-3">
      <div className="flex items-start gap-2">
        <FileText className="mt-0.5 h-4 w-4 shrink-0 text-blue-600" />
        <div className="min-w-0 flex-1">
          <div className="mb-1 text-sm font-medium text-blue-900">Call Summary</div>
          <div className="whitespace-pre-wrap [overflow-wrap:anywhere] text-sm leading-relaxed text-blue-800">{summary}</div>
        </div>
      </div>
    </div>
  )
}
